import React from "react";
import { useSelector } from "react-redux";

const SpinnerComponent = () => {
  const { Wait } = useSelector((state) => state);

  if (!Wait) {
    return null;
  }

  return (
    <div className="div-spinner">
      <div className="div-fas-spinner">
        <i className="fas fa-spinner fa-pulse fa-3x"></i>
      </div>
    </div>
  );
};

export default SpinnerComponent;
